// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"75608000","453":"9adfd3e2","856":"7e31bbcb"}[chunkId] + ".chunk.js";
};